import { createFileRoute, useRouter } from '@tanstack/react-router';

import TermsAndConditionsContent from '../../components/TermsAndConditionsContent';
import PageHeader from 'src/components/PageHeader';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';

export const Route = createFileRoute('/(app)/termsAndConditions')({
    component: HomeComponent,
});

function HomeComponent() {
    const { history } = useRouter();

    return (
        <InnerMaxWidthContainer>
            <PageHeader pageTitle="Terms and Conditions" onBack={() => history.back()} />
            <TermsAndConditionsContent />
        </InnerMaxWidthContainer>
    );
}
